import { Checkbox } from '@ksyos/design-system';
import type { MedicationRecord, Medications } from './medications';
import { TableData, TableRow } from '../../../../../elements/common';
import { ProfessionalSummaryDataAction } from '../../../../professionalSummaryData/ProfessionalSummaryDataSection';
import { isCurrentMedication } from './medications';
import { MedicationsTableRow } from './MedicationsTableRow';

interface IMedicationsPickableTableRowProps {
    medication: MedicationRecord;
    medicationKey: string;
    medications: Medications;
    onChange: (medications: Medications) => Promise<void>;
}

export function MedicationsPickableTableRow(props: IMedicationsPickableTableRowProps) {
    return (
        <TableRow
            highlight={isCurrentMedication(props.medication)}
            key={props.medicationKey}
        >
            <TableData className="has-checkbox">
                <Checkbox
                    checked={props.medication.action === ProfessionalSummaryDataAction.pick}
                    onChange={async (event) =>
                        await props.onChange(
                            props.medications.setIn(
                                [props.medicationKey, 'action'],
                                event.target.checked
                                    ? ProfessionalSummaryDataAction.pick
                                    : ProfessionalSummaryDataAction.skip
                            )
                        )
                    }
                />
            </TableData>
            <MedicationsTableRow medication={props.medication} />
        </TableRow>
    );
}
